// Shared helpers for displaying the next webinar slot dynamically.
// Webinar slots: 10:00, 13:00, 20:00 Europe/Amsterdam time.
const SLOTS = [10, 13, 20] as const
const DAYS_NL = [
  'zondag',
  'maandag',
  'dinsdag',
  'woensdag',
  'donderdag',
  'vrijdag',
  'zaterdag',
]
const MONTHS_NL = [
  'januari',
  'februari',
  'maart',
  'april',
  'mei',
  'juni',
  'juli',
  'augustus',
  'september',
  'oktober',
  'november',
  'december',
]
const MONTHS_NL_SHORT = [
  'jan',
  'feb',
  'mrt',
  'apr',
  'mei',
  'jun',
  'jul',
  'aug',
  'sep',
  'okt',
  'nov',
  'dec',
]
function amsterdamNow(): Date {
  return new Date(
    new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }),
  )
}
export type WebinarSlot = {
  // Day prefix label in Dutch, e.g. "Vandaag" or "Morgen"
  dayPrefix: 'Vandaag' | 'Morgen'
  // Full date label, e.g. "dinsdag 2 juni"
  dateLabel: string
  // Short date label, e.g. "2 jun"
  dateLabelShort: string
  // Time label, e.g. "10:00"
  time: string
  // Convenience full label, e.g. "Vandaag dinsdag 2 juni 10:00"
  fullLabel: string
}
// Returns the next webinar slot to show. If all of today's slots have passed,
// rolls over to tomorrow at 10:00 (with "Morgen" prefix).
export function getNextWebinarSlot(): WebinarSlot {
  const now = amsterdamNow()
  const currentHour = now.getHours()
  let prefix: 'Vandaag' | 'Morgen' = 'Vandaag'
  let day = new Date(now)
  let nextHour: number | undefined
  for (const slot of SLOTS) {
    if (slot > currentHour) {
      nextHour = slot
      break
    }
  }
  if (nextHour === undefined) {
    // All slots passed; next is tomorrow 10:00
    prefix = 'Morgen'
    day = new Date(now)
    day.setDate(day.getDate() + 1)
    nextHour = 10
  }
  const dayName = DAYS_NL[day.getDay()]
  const dateNum = day.getDate()
  const monthLong = MONTHS_NL[day.getMonth()]
  const monthShort = MONTHS_NL_SHORT[day.getMonth()]
  const dateLabel = `${dayName} ${dateNum} ${monthLong}`
  const dateLabelShort = `${dateNum} ${monthShort}`
  const time = `${nextHour}:00`
  return {
    dayPrefix: prefix,
    dateLabel,
    dateLabelShort,
    time,
    fullLabel: `${prefix} ${dateLabel} ${time}`,
  }
}
